import type { FunctionComponent } from "react";
import { LoginAuthCommonPartial } from "../../../partials/common/auth/login-auth.common.partials";
import { Navigate, useSearchParams } from "react-router-dom";
import { LoginBrandAuthCommonPartial } from "../../../partials/common/auth/brand/login-brand-auth.common.partials";
import { useUserStore } from "../../../store/user.store";
import { AccountType } from "../../../constants/account-types.constants";

export const LoginAuthCommonScreen: FunctionComponent = () => {
	const [searchParams] = useSearchParams();
	const campaign = searchParams.get("campaign");
	const { token, user } = useUserStore();

	// A signed-in admin should land in the dashboard, including when the
	// browser back button returns to this route.
	if (!campaign && token && user?.accountType === AccountType.ADMIN) {
		return <Navigate to="/admin" replace />;
	}

	if (campaign) {
		return <LoginBrandAuthCommonPartial/>;
	}
	return <LoginAuthCommonPartial />;
};
